import { memo, ReactNode } from 'react';
import { Box } from '@chakra-ui/react';

import { BUILDER_MODE_V1_LAYOUT, BUILDER_MODE_V1_TOKENS } from '../../constants';

export interface InputPanelChartSectionV1Properties {
  children: ReactNode;
}

const InputPanelChartSectionV1 = memo(({ children }: InputPanelChartSectionV1Properties) => (
  <Box
    w='100%'
    flexShrink={0}
    border='1px solid'
    borderColor={BUILDER_MODE_V1_TOKENS.border}
    borderRadius={BUILDER_MODE_V1_LAYOUT.inputPanelChartRadius}
    overflow='hidden'
    bg={BUILDER_MODE_V1_TOKENS.white}
    minH='120px'
    h='25vh'
    maxH='190px'
  >
    {children}
  </Box>
));

InputPanelChartSectionV1.displayName = 'InputPanelChartSectionV1';

export default InputPanelChartSectionV1;
